<template>
  <div :class="$style.page">
    <BaseContainer :class="$style.container">
      <form @submit.prevent="submit">
        <BaseLoader
          :class="$style.box"
          :is-active="isFormLoading"
        >
          <FormBox
            :heading="formStepData.heading"
            :lead="formStepData.lead"
          >
            <template v-if="formStep === 1">
              <div :class="$style.billingSection">
                <h4 :class="$style.billingHeading">
                  Type
                </h4>
                <div :class="$style.billingOptions">
                  <div
                    v-for="option in $options.BILLING_OPTIONS"
                    :key="option.value"
                    :class="$style.billingOption"
                    @click.exact="billing = option.value"
                  >
                    <BaseLabeledRadio
                      v-model="billing"
                      :value="option.value"
                      is-dark
                    >
                      {{ option.label }}
                    </BaseLabeledRadio>
                  </div>
                </div>
              </div>
            </template>

            <template #footer>
              <BaseButton
                variant="success"
                type="submit"
                is-block
              >
                {{ formStepData.submitText }}
              </BaseButton>
            </template>
          </FormBox>
        </BaseLoader>
      </form>
    </BaseContainer>
  </div>
</template>

<script>
import gql from 'graphql-tag';
import BaseContainer from '@/components/base/Container';
import BaseLabeledRadio from '@/components/base/LabeledRadio';
import BaseButton from '@/components/base/Button';
import BaseLoader from '@/components/base/Loader';
import FormBox from '@/components/FormBox';
import { billingTypes } from '@/config';

export default {
  components: {
    BaseContainer,
    BaseLabeledRadio,
    BaseButton,
    BaseLoader,
    FormBox,
  },
  BILLING_OPTIONS: billingTypes,
  data() {
    return {
      company: null,
      billing: null,
      isFormLoading: false,
      formStep: 1,
    };
  },
  computed: {
    formStepData() {
      if (this.formStep === 1) {
        return {
          heading: `${this.company ? this.company.name : 'Company'} billing details`,
          lead: 'These are for your records as you raise invoices manually.',
          submitText: 'Save',
        };
      }
      return {
        heading: 'Billing details saved',
        submitText: 'Go to company settings',
      };
    },
  },
  created() {
    this.loadCompany();
  },
  methods: {
    async loadCompany() {
      this.isFormLoading = true;

      const { data } = await this.$apollo.query({
        query: gql`query ($companyId: Int!) {
          companies_by_pk(id: $companyId) {
            id
            name
            billing_type
          }
        }`,
        variables: {
          companyId: this.$route.params.companyId,
        },
        fetchPolicy: 'no-cache',
      });

      this.company = data.companies_by_pk;
      this.billing = this.company.billing_type;
      this.isFormLoading = false;
    },
    async saveBillingDetails() {
      this.isFormLoading = true;

      await this.$apollo.mutate({
        mutation: gql`mutation ($companyId: Int!, $billingType: String!) {
          update_companies_by_pk(pk_columns: {id: $companyId}, _set: {billing_type: $billingType}) {
            id
          }
        }`,
        variables: {
          companyId: this.$route.params.companyId,
          billingType: this.billing,
        },
      });

      this.isFormLoading = false;
      this.formStep += 1;
    },
    submit() {
      switch (this.formStep) {
        case 1:
          return this.saveBillingDetails();
        case 2:
          return this.$router.push({ name: 'EditCompany', params: { companyId: this.$route.params.companyId } });
        default:
          return null;
      }
    },
  },
};
</script>

<style lang="scss" module>
.page {
  flex-grow: 1;
  padding-top: map-get($page-vertical-paddings, 'small');
  padding-bottom: map-get($page-vertical-paddings, 'small');
  background: #fafafa;
}

.container {
  display: flex;
  justify-content: center;
}

.box {
  width: 470px;
}

.field {

  &:not(:first-child) {
    margin-top: 20px;
  }
}

.multiselect {
  width: 100%;
}

.billingSection {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px;
  background: $background-light;
  border-radius: 5px;
}

.billingHeading {
  margin: 0;
  font-size: 16px;
  color: $title;
}

.billingOptions {
  display: flex;
}

.billingOption {
  padding: 8px;
  background: $white;
  border: 1px solid #e6e6e6;
  border-radius: 5px;

  &:not(:first-child) {
    margin-left: 5px;
  }
}
</style>
